import React from "react";
import { PageLayout } from "../ui-components/PageLayout";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Box,
  Badge,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import FieldVisibilitySettings from "../ui-components/Settings/FieldVisibilitySettings";
import DropdownOptionsManager from "../ui-components/Settings/DropdownOptionsManager";
import NamesDirectoryManager from "../ui-components/Settings/NamesDirectoryManager";
import FinancialSettings from "../ui-components/Settings/FinancialSettings";
import TeamMemberFilterSettings from "../ui-components/Settings/TeamMemberFilterSettings";
import { useSelector } from "react-redux";
import { RootState } from "../store/reducers";

const Settings = () => {
  const { currentUser: user } = useSelector((state: RootState) => state?.user);
  const { hiddenFields } = useSelector(
    (state: RootState) => state.hiddenFields,
  );

  const isCoAgentFilterVisible = !hiddenFields?.some(
    (field) => field.name === "coAgent",
  );

  const { selectedCoAgentIds } = useSelector(
    (state: RootState) => state.coAgentFilter,
  );

  return (
    <PageLayout>
      <Box sx={{ mb: 6, ml: 1 }}>
        <Typography
          color="primary"
          variant="h4"
          component="h1"
          fontWeight="bold"
          gutterBottom
        >
          Settings
        </Typography>

        <Accordion
          sx={{
            mb: 4,
            borderTopRightRadius: "16px",
            borderBottomRightRadius: "16px",
            // boxShadow: "0 4px 24px 0 rgba(26,54,93,0.10)",

            boxShadow: "0 4px 24px 0 rgba(26,54,93,0.10)",
            borderLeft: "8px solid",
            // borderLeftColor: "accent.main",
            borderLeftColor: "primary.main",
            // background: "linear-gradient(90deg, #f7f9fc 80%, #ede7f6 100%)",
            background: "linear-gradient(90deg, #f7f9fc 80%, #e6e6e6 100%)",

            overflow: "hidden",
            "&:before": { display: "none" },
          }}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon sx={{ color: "primary.main" }} />}
            sx={{
              // background: "rgba(155,135,245,0.07)",
              background: "rgba(26,54,93,0.07)",
              minHeight: 64,
              px: 3,
              py: 2,
              "& .MuiTypography-root": {
                fontWeight: 600,
                fontSize: "1.15rem",
                color: "primary.main", //"accent.main",
                letterSpacing: 0.2,
              },
            }}
          >
            <Typography
              variant="subtitle1"
              sx={{ display: "flex", alignItems: "center" }}
            >
              <Box
                sx={{
                  width: 10,
                  height: 10,
                  borderRadius: "50%",
                  background: "secondary.main",
                  mr: 1.5,
                  boxShadow: "0 0 0 2px #fff, 0 0 0 4px #C69F26",

                  // boxShadow: "0 0 0 2px #fff, 0 0 0 4px #9b87f5",
                }}
              />
              Category Options
            </Typography>
          </AccordionSummary>
          <AccordionDetails
            sx={{
              background: "#fff",
              px: { xs: 1, md: 3 },
              py: 3,
              borderBottomLeftRadius: "16px",
              borderBottomRightRadius: "16px",
            }}
          >
            <FieldVisibilitySettings />
          </AccordionDetails>
        </Accordion>

        {/* <Accordion
          sx={{
            mb: 4,
            borderTopRightRadius: "16px",
            borderBottomRightRadius: "16px",
            boxShadow: "0 4px 24px 0 rgba(26,54,93,0.10)",
            borderLeft: "8px solid",
            borderLeftColor: "primary.main",
            background: "linear-gradient(90deg, #f7f9fc 80%, #e6e6e6 100%)",
            overflow: "hidden",
            "&:before": { display: "none" },
          }}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon sx={{ color: "primary.main" }} />}
            sx={{
              background: "rgba(26,54,93,0.07)",
              minHeight: 64,
              px: 3,
              py: 2,
              "& .MuiTypography-root": {
                fontWeight: 600,
                fontSize: "1.15rem",
                color: "primary.main",
                letterSpacing: 0.2,
              },
            }}
          >
            <Typography
              variant="subtitle1"
              sx={{ display: "flex", alignItems: "center" }}
            >
              <Box
                sx={{
                  width: 10,
                  height: 10,
                  borderRadius: "50%",
                  background: "secondary.main",
                  mr: 1.5,
                  boxShadow: "0 0 0 2px #fff, 0 0 0 4px #C69F26",
                }}
              />
              Area Type Preferences
            </Typography>
          </AccordionSummary>
          <AccordionDetails
            sx={{
              background: "#fff",
              px: { xs: 1, md: 3 },
              py: 3,
              borderBottomLeftRadius: "16px",
              borderBottomRightRadius: "16px",
            }}
          >
            <AreaTypeSettings />
          </AccordionDetails>
        </Accordion> */}

        <Accordion
          sx={{
            mb: 4,
            borderTopRightRadius: "16px",
            borderBottomRightRadius: "16px",
            boxShadow: "0 4px 24px 0 rgba(26,54,93,0.10)",
            borderLeft: "8px solid",
            borderLeftColor: "primary.main",
            background: "linear-gradient(90deg, #f7f9fc 80%, #e6e6e6 100%)",

            overflow: "hidden",
            "&:before": { display: "none" },
          }}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon sx={{ color: "primary.main" }} />}
            sx={{
              background: "rgba(26,54,93,0.07)",
              minHeight: 64,
              px: 3,
              py: 2,
              "& .MuiTypography-root": {
                fontWeight: 600,
                fontSize: "1.15rem",
                color: "primary.main", //"accent.main",
                letterSpacing: 0.2,
              },
            }}
          >
            <Typography
              variant="subtitle1"
              sx={{ display: "flex", alignItems: "center" }}
            >
              <Box
                sx={{
                  width: 10,
                  height: 10,
                  borderRadius: "50%",
                  background: "secondary.main",
                  mr: 1.5,
                  boxShadow: "0 0 0 2px #fff, 0 0 0 4px #C69F26",
                }}
              />
              Sub-Category Options
            </Typography>
          </AccordionSummary>
          <AccordionDetails
            sx={{
              background: "#fff",
              px: { xs: 1, md: 3 },
              py: 3,
              borderBottomLeftRadius: "16px",
              borderBottomRightRadius: "16px",
            }}
          >
            <DropdownOptionsManager />
          </AccordionDetails>
        </Accordion>

        <Accordion
          sx={{
            mb: 4,
            borderTopRightRadius: "16px",
            borderBottomRightRadius: "16px",
            boxShadow: "0 4px 24px 0 rgba(26,54,93,0.10)",
            borderLeft: "8px solid",
            borderLeftColor: "primary.main",
            background: "linear-gradient(90deg, #f7f9fc 80%, #e6e6e6 100%)",
            overflow: "hidden",
            "&:before": { display: "none" },
          }}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon sx={{ color: "primary.main" }} />}
            sx={{
              background: "rgba(26,54,93,0.07)",
              minHeight: 64,
              px: 3,
              py: 2,
              "& .MuiTypography-root": {
                fontWeight: 600,
                fontSize: "1.15rem",
                color: "primary.main",
                letterSpacing: 0.2,
              },
            }}
          >
            <Typography
              variant="subtitle1"
              sx={{ display: "flex", alignItems: "center" }}
            >
              <Box
                sx={{
                  width: 10,
                  height: 10,
                  borderRadius: "50%",
                  background: "secondary.main",
                  mr: 1.5,
                  boxShadow: "0 0 0 2px #fff, 0 0 0 4px #C69F26",
                }}
              />
              Names Directory
            </Typography>
          </AccordionSummary>
          <AccordionDetails
            sx={{
              background: "#fff",
              px: { xs: 1, md: 3 },
              py: 3,
              borderBottomLeftRadius: "16px",
              borderBottomRightRadius: "16px",
            }}
          >
            <NamesDirectoryManager />
          </AccordionDetails>
        </Accordion>

        <Accordion
          sx={{
            mb: 4,
            borderTopRightRadius: "16px",
            borderBottomRightRadius: "16px",
            // boxShadow: "0 4px 24px 0 rgba(26,54,93,0.10)",

            boxShadow: "0 4px 24px 0 rgba(26,54,93,0.10)",
            borderLeft: "8px solid",
            // borderLeftColor: "accent.main",
            borderLeftColor: "primary.main",
            // background: "linear-gradient(90deg, #f7f9fc 80%, #ede7f6 100%)",
            background: "linear-gradient(90deg, #f7f9fc 80%, #e6e6e6 100%)",

            overflow: "hidden",
            "&:before": { display: "none" },
          }}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon sx={{ color: "primary.main" }} />}
            sx={{
              background: "rgba(26,54,93,0.07)",
              minHeight: 64,
              px: 3,
              py: 2,
              "& .MuiTypography-root": {
                fontWeight: 600,
                fontSize: "1.15rem",
                color: "primary.main",
                letterSpacing: 0.2,
              },
            }}
          >
            <Typography
              variant="subtitle1"
              sx={{ display: "flex", alignItems: "center" }}
            >
              <Box
                sx={{
                  width: 10,
                  height: 10,
                  borderRadius: "50%",
                  background: "secondary.main",
                  mr: 1.5,
                  boxShadow: "0 0 0 2px #fff, 0 0 0 4px #C69F26",
                }}
              />
              Financial Settings
            </Typography>
          </AccordionSummary>
          <AccordionDetails
            sx={{
              background: "#fff",
              px: { xs: 1, md: 3 },
              py: 3,
              borderBottomLeftRadius: "16px",
              borderBottomRightRadius: "16px",
            }}
          >
            <FinancialSettings />
          </AccordionDetails>
        </Accordion>

        {/* Team Member Filter Section - Admin Only */}
        {isCoAgentFilterVisible && (
          <Accordion
            sx={{
              mb: 4,
              borderTopRightRadius: "16px",
              borderBottomRightRadius: "16px",
              boxShadow: "0 4px 24px 0 rgba(26,54,93,0.10)",
              borderLeft: "8px solid",
              borderLeftColor: "primary.main",
              background: "linear-gradient(90deg, #f7f9fc 80%, #e6e6e6 100%)",
              overflow: "hidden",
              "&:before": { display: "none" },
            }}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon sx={{ color: "primary.main" }} />}
              sx={{
                background: "rgba(26,54,93,0.07)",
                minHeight: 64,
                px: 3,
                py: 2,
                "& .MuiTypography-root": {
                  fontWeight: 600,
                  fontSize: "1.15rem",
                  color: "primary.main",
                  letterSpacing: 0.2,
                },
              }}
            >
              <Typography
                variant="subtitle1"
                sx={{ display: "flex", alignItems: "center" }}
              >
                <Box
                  sx={{
                    width: 10,
                    height: 10,
                    borderRadius: "50%",
                    background: "secondary.main",
                    mr: 1.5,
                    boxShadow: "0 0 0 2px #fff, 0 0 0 4px #C69F26",
                  }}
                />
                <Badge
                  badgeContent={selectedCoAgentIds.length}
                  color="secondary"
                  invisible={selectedCoAgentIds.length === 0}
                  anchorOrigin={{
                    vertical: "top",
                    horizontal: "right",
                  }}
                  sx={{ ml: 0.5 }}
                >
                  <Box component="span">Global Team Member Filter</Box>
                </Badge>
              </Typography>
            </AccordionSummary>
            <AccordionDetails
              sx={{
                background: "#fff",
                px: { xs: 1, md: 3 },
                py: 3,
                borderBottomLeftRadius: "16px",
                borderBottomRightRadius: "16px",
              }}
            >
              <TeamMemberFilterSettings />
            </AccordionDetails>
          </Accordion>
        )}
      </Box>
    </PageLayout>
  );
};

export default Settings;
